// src/pages/SalesMetricsView.tsx

import React from 'react';
import RevenueOverviewCard from './RevenueOverviewCard';
import RevenueTrendsChart from './RevenueTrendsChart';
import PerformanceLineChart from './PerformanceLineChart';
import { revenueCards, revenueTrendsData, performanceData } from './DashboardConfig';

// Renamed component from Dashboard to SalesMetricsView
const SalesMetricsView: React.FC = () => {
  return (
    <div className=" ">
      <h2 className="text-xl font-bold ">Revenue Overview</h2>

      {/* Top Section: Overview Cards and Revenue Trends Chart */}
      <div className="grid grid-cols-12 gap-6">

        {/* Left Column: Revenue Overview Cards (Col span 4) */}
        <div className="col-span-12 lg:col-span-4 space-y-4">
          {revenueCards.map((card, index) => (
            <RevenueOverviewCard key={index} data={card} />
          ))}
        </div>

        {/* Right Column: Revenue Trends Chart (Col span 8) */}
        <div className="col-span-12 lg:col-span-8">
          <RevenueTrendsChart data={revenueTrendsData} />
        </div>
      </div>

      {/* Bottom Section: Performance Line Chart */}
      <PerformanceLineChart data={performanceData} />
    </div>
  );
};

export default SalesMetricsView;